import styled from 'styled-components';

export const HeaderEndCluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const RunStatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font: 500 11px/1.4
    'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#9495B0'};
`;

/**
 * Inline title rename input — matches the design's
 * `.ns-node__title-input`: same 15px/600 font as the title label,
 * compact padding, low-contrast fill so it reads as "editing in place"
 * rather than a full form field.
 */
export const RenameInput = styled.input`
  width: 100%;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: 4px;
  padding: 1px 4px;
  font: 600 15px/1.3
    'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
  outline: none;

  &:focus {
    border-color: ${({ theme: { colors = {} } }) =>
      colors.primary ?? '#C1C1FF'};
  }
`;
